import React, { useState, useEffect, useCallback } from "react";
import CommonCard from "../common/commonCard";
import Header from "../common/header";
import Sidebar from "../common/navBar";
import { Container, Row, Col, Button } from "react-bootstrap";
import FormCard from "../common/formCard";
import RTE from "../common/RTE";
import Footer from "../common/footer";
import MessagePopUp from "../common/messagePopUp";
import { useNavigate } from "react-router-dom";
import { GetUsersSelectService } from "../../Services/userService";
import { PostCompanyService } from "../../Services/companyService";
import { getFileInformation } from "../../utils/base64Conver";
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import CustomTabs, { CustomTab } from "../common/customTabs";
import DownloadCertificationsPopUp from "../specific/downloadCertificationsPopUp";


const CreateCompany = () => {
  const [t] = useTranslation("companies")
  const [expanded, setExpanded] = useState(false);
  const [file, setFile] = useState(null);
  const [formDenunciasText, setFormDenunciasText] = useState("");
  const [responsibleOptions, setResponsibleOptions] = useState([]);
  const [responsibleFunctionsOptions, setResponsibleFunctionsOptions] =
    useState([]);
  const [responsibleManagementOptions, setResponsibleManagementOptions] = useState([]);
  const [showPopupError, setShowPopupError] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const [showPopupContinue, setShowPopupContinue] = useState(false);
  const [showModalContinue, setShowModalContinue] = useState(false);
  const [showDownloadResponsibles, setShowDownloadResponsibles] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [changeData, setChangeData] = useState(false);



  //primer formulario
  const [formData, setFormData] = useState({
    nifCif: "",
    name: "",
    responsibleId: "",
    functionsResponsibleId: null,
    responsibleManagementId: null,
    link: "",
    text: "",
    image: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchDataResponsibleOptions = async () => {
      try {
        const result = await GetUsersSelectService();
        const formattedData = result
          .filter((data) => data.user !== formData.functionsResponsibleId)
          .map((data) => ({
            label: `${data.name} ${data.surname} (${data.nif})`,
            value: data.user,
          }));

        const formattedDataFunctions = result
          .filter((data) => data.user !== formData.responsibleId)
          .map((data) => ({
            label: `${data.name} ${data.surname} (${data.nif})`,
            value: data.user,
          }));

        const formattedDataManagement = result
          .map((data) => ({
            label: `${data.name} ${data.surname} (${data.nif})`,
            value: data.user,
          }));

        if (formData.functionsResponsibleId) {
          formattedDataFunctions.unshift({
            label: "---",
            value: "NULL",
          });
        }


        setResponsibleOptions(formattedData);
        setResponsibleFunctionsOptions(formattedDataFunctions);
        setResponsibleManagementOptions(formattedDataManagement)
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchDataResponsibleOptions();
  }, [formData]);

  const [isFormValid, setIsFormValid] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    name: false,
    nameMessage: null,
    text: null,
    image: null,
  });

  useEffect(() => {
    const allFieldsValid = Object.values(fieldErrors).every((error) => !error);
    setIsFormValid(allFieldsValid);
  }, [fieldErrors]);

  const validateField = async (field, value) => {
    let isError = false;
    let errorMessage = null;

    switch (field) {
      case "nifCif":
        isError = !isValidNIFCIF(value);
        errorMessage = isError
          ? `${t("companyForm.nifError")}`
          : null;
        break;
      case "name":
        isError = value === "";
        errorMessage = isError
          ? `${t("companyForm.nameError")}`
          : null;
        break;
      case "responsibleId":
        isError = value === "";
        errorMessage = isError
          ? `${t("companyForm.responsibleError")}`
          : null;
        break;

      /* case "responsibleManagementId":
        isError = value === "";
        errorMessage = isError
          ? `${t("companyForm.managementResponsibleError")}`
          : null;
        break; */

      case "text":
        isError = !isValidNIFCIF(value);
        errorMessage = isError
          ? `${t("companyForm.textError")}`
          : null;
        break;
      case "image":

        if (value === null || value === '') {
          isError = true;
          errorMessage = `${t("companyForm.imageError")}`
          break;
        }

        const url = URL.createObjectURL(value);

        let img;
        let fileSizeKB;

        if (value) {
          img = new Image();

          // Esperar hasta que la imagen se haya cargado
          await new Promise((resolve) => {
            img.onload = resolve;
            img.src = url;
          });

          fileSizeKB = Math.round((value.size / 1024) * 100) / 100;
        }
        if (
          (img.width > 1000 || img.width < 700) ||
          (img.height > 350 || img.height < 150)
        ) {
          isError = true;
          errorMessage = isError
            ? `${t("companyForm.imageSizeError")}`
            : null;
        } else if (fileSizeKB > 2000) {
          isError = true;
          errorMessage = isError
            ? `${t("companyForm.imageWeightError")}`
            : null;
        }
        break;

      default:
        break;
    }
    setFieldErrors((prevFieldErrors) => {
      const newErrors = { ...prevFieldErrors, [field]: isError };
      newErrors[`${field}Message`] = errorMessage;
      return newErrors;
    });
    return !isError;
  };

  const handleFieldChange = (field, value) => {
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, [field]: value };
      validateField(field, value); // Validar el campo cuando se actualiza

      return updatedFormData;
    });
  };

  const validateAllFields = async () => {
    const { nifCif, name, responsibleId, text, image, responsibleManagementId } = formData;

    const isNameValid = await validateField("name", name);

    const isNifCifValid = await validateField("nifCif", nifCif);

    const isResponsibleValid = await validateField("responsibleId", responsibleId);

    const isResponsibleManagementValid = await validateField("responsibleManagementId", responsibleManagementId);

    const isImageValid = await validateField("image", image);

    return isNameValid && isNifCifValid && isResponsibleValid && isResponsibleManagementValid && isImageValid;
  };

  const isValidCIF = (cif) => {
    const regex = /^[A-Za-z][0-9]{7}[A-Za-z0-9]$/;
    return regex.test(cif);
  };

  const isValidNIF = (nif) => {
    const nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
    const nieRegex = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
    const letters = "TRWAGMYFPDXBNJZSQVHLCKE";
    let number, letter;

    if (nifRegex.test(nif)) {
      number = parseInt(nif.slice(0, 8), 10);
      letter = nif.slice(8).toUpperCase();
    } else if (nieRegex.test(nif)) {
      const initialLetterMappings = { X: "0", Y: "1", Z: "2" };
      const initialLetter = nif[0].toUpperCase();
      number = parseInt(
        initialLetterMappings[initialLetter] + nif.slice(1, 8),
        10
      );
      letter = nif.slice(8).toUpperCase();
    } else {
      return false; // No es ni NIF ni NIE válido
    }

    return letters[number % 23] === letter;
  };

  const isValidNIFCIF = (string) => {
    if (isValidCIF(string) || isValidNIF(string)) {
      return true;
    }
    return false;
  };

  const handleButtonMessagePopUpErrorClick = () => {
    setShowPopupError(false);
    setShowModalError(true);
  };

  const handleButtonMessagePopUpContinueClick = () => {
    setShowPopupContinue(false);
    setShowModalContinue(true);
    setShowDownloadResponsibles(true)

  };
  const handleDownloadResponsiblesClick = () => {
    setShowDownloadResponsibles(false)
    navigate(`/edit-company/${apiData.company}`, { state: { data: apiData } });
  };



  const handleSaveClick = useCallback(async () => {
    setLoading(true)
    if (await validateAllFields()) {
      const newFormDenunciasText =
        "https://app.myreportin.com/public/0b64fa64-d799-4fd1-8c2e-7007c27d25dd";
      setFormDenunciasText(newFormDenunciasText);
      setFormData((prevFormData) => {
        const updatedFormData = { ...prevFormData, link: newFormDenunciasText };
        return updatedFormData;
      });

      if (file !== null && file !== '') {
        const response = await getFileInformation(file);
        formData.image = response;

      }
      setLoading(false)
      const apiResponse = await PostCompanyService(formData);
      setApiData(apiResponse);
      if (typeof apiResponse !== 'object') {
        setShowPopupError(true);
        setLoading(false)
      } else {
        setShowPopupContinue(true);
        setLoading(false)
      }
    }
    setLoading(false)

  });



  const handleCancelClick = async () => {
    navigate("/companies");
  };


  const handleEditorContentChange = (newContent) => {
    setFormData((prevFormData) => ({ ...prevFormData, text: newContent }));
  };

  const optionsNumber = (options) => {
    var cont = 0;
    options.forEach((option) => {
      if (option.value !== null && option.value !== "") {
        cont++;
      }
    });
    if (cont >= 1) {
      return false;
    }
    return true;
  };

  return (
    <div>
      <MessagePopUp
        show={showPopupError}
        handleClose={() => setShowPopupError(false)}
        title={apiData === "Error NIF" ? `${t("companiesPopup.nifErrorTitle")}` : `${t("companiesPopup.mailErrorTitle")}`}
        textBody={
          apiData === "Error NIF"
            ? `${t("companiesPopup.nifErrorText")}`
            : `${t("companiesPopup.mailErrorText")}`
        }
        buttonText={t("companiesPopup.acceptButton")}
        onClickButton={handleButtonMessagePopUpErrorClick}
      />
      <MessagePopUp
        show={showPopupContinue}
        handleClose={() => setShowPopupContinue(false)}
        title={t("companiesPopup.companySuccessText")}
        textBody={t("companiesPopup.companySuccessTextMessage")}
        buttonText={t("companiesPopup.acceptButton")}
        onClickButton={handleButtonMessagePopUpContinueClick}
      />
      <DownloadCertificationsPopUp
        show={showDownloadResponsibles}
        handleClose={handleDownloadResponsiblesClick}
        title={t("certificationsDownloadPopUp.popupDownloadResponsiblesTitle")}
        id={'responsibles'}
      />

      <Header
        manual={'https://www.africau.edu/images/default/sample.pdf'}
        reloadData={() => setChangeData(!changeData)}
      />
      <Container fluid>
        <Row>
          <Col
            className='d-flex'
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "2%" : "4%"}`,
            }}
          >
            <Sidebar
              expanded={expanded}
              setExpanded={setExpanded}
              selected={"Empresas"}
            />
          </Col>
          <Col
            className='custom-content-wrapper'

            style={{
              marginLeft: `0.5%`,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "86%" : "93%"}`,
            }}
          >
            <Row>
              <Col md={12}>
                <CommonCard title={t("createCompanyCard.title")} icon="FaBuilding">
                  <Row>
                    <Col md={6}>
                      <FormCard
                        title={t("companyForm.nif")}
                        type={"text"}
                        error={fieldErrors.nifCif}
                        errorMessage={fieldErrors.nifCifMessage}
                        readOnly={false}
                        onChange={(e) =>
                          handleFieldChange("nifCif", e.target.value)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <FormCard
                        title={t("companyForm.name")}
                        type={"text"}
                        error={fieldErrors.name}
                        errorMessage={fieldErrors.nameMessage}
                        readOnly={false}
                        onChange={(e) =>
                          handleFieldChange("name", e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormCard
                        title={t("companyForm.responsible")}
                        type={"select"}
                        error={fieldErrors.responsibleId}
                        errorMessage={fieldErrors.responsibleIdMessage}
                        onChange={(e) =>
                          handleFieldChange("responsibleId", e.value)
                        }
                        options={responsibleOptions}
                      />
                    </Col>
                    <Col md={6}>
                      <FormCard
                        title={t("companyForm.functionsResponsible")}
                        type={"select"}
                        readOnly={!formData.responsibleId || optionsNumber(responsibleFunctionsOptions)}
                        options={responsibleFunctionsOptions}
                        onChange={(e) =>
                          handleFieldChange("functionsResponsibleId", e.value)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    {/* <Col md={6}>
                      <FormCard
                        title={t("companyForm.managementResponsible")}
                        type={"select"}
                        error={fieldErrors.responsibleManagementId}
                        errorMessage={fieldErrors.responsibleManagementIdMessage}
                        options={responsibleManagementOptions}
                        onChange={(e) =>
                          handleFieldChange("responsibleManagementId", e.value)
                        }
                      />
                    </Col> */}
                    <Col md={6}>
                      <FormCard
                        title={t("companyForm.link")}
                        text={formDenunciasText}
                        type={"text"}
                        readOnly={true}
                        copyClipBoard={true}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-4">

                    <Col md={8}>
                      <CustomTabs text={t("companyForm.customTabsTitle")}>
                        <CustomTab title={'Español'} >
                        </CustomTab>
                      </CustomTabs>
                      <RTE onContentChange={handleEditorContentChange} key={changeData} />
                    </Col>

                    <Col md={4} className="margin-top-6">
                      <FormCard
                        title={t("companyForm.image")}
                        type={"file"}
                        error={fieldErrors.image}
                        errorMessage={fieldErrors.imageMessage}
                        setFile={setFile}
                        onChange={(e) => handleFieldChange("image", e)}
                      />
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-around mt-4">
                    <Button
                      className="custom-shadow custom-button-secondary"
                      variant="secondary"
                      onClick={handleCancelClick}
                      disabled={loading}
                    >
                      {t("companyForm.cancelbutton")}
                    </Button>
                    <Button
                      className="custom-shadow custom-button-primary"
                      variant="success"
                      onClick={handleSaveClick}
                      disabled={!isFormValid || loading}
                    >
                      {loading ?
                        <>
                          <Spinner animation="border" className="spinner" />
                          <span className="common-card-card-text">{t("companyForm.savingbutton")}</span>

                        </>
                        :
                        <>
                          {t("companyForm.savebutton")}
                        </>
                      }
                    </Button>
                  </div>
                </CommonCard>
              </Col>
            </Row>
            <Footer />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CreateCompany;
